"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Minus24PxOutlined_1 = __importDefault(require("../../elements/icons-jb/Minus24PxOutlined"));
var Plus24PxOutlined_1 = __importDefault(require("../../elements/icons-jb/Plus24PxOutlined"));
var Input_1 = __importDefault(require("../../elements/input/Input"));
var Stepper_module_scss_1 = __importDefault(require("./Stepper.module.scss"));
var useStepper_1 = require("./useStepper");
var Stepper = function (_a) {
    var value = _a.value, handleChange = _a.handleChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.min, min = _c === void 0 ? 0 : _c, _d = _a.max, max = _d === void 0 ? 99 : _d, inputId = _a.inputId, inputName = _a.inputName, className = _a.className, rest = __rest(_a, ["value", "handleChange", "disabled", "min", "max", "inputId", "inputName", "className"]);
    if (min < -99) {
        console.warn('Stepper: It is recommended not to use min value lower than -99 as the digits will overflow the containing box');
    }
    if (max > 99) {
        console.warn('Stepper: It is recommended not to use max value higher than 99 as the digits will overflow the containing box');
    }
    var _e = (0, useStepper_1.useStepper)({ value: value, max: max, min: min, handleChange: handleChange }), handleDecrement = _e.handleDecrement, handleIncrement = _e.handleIncrement, handleInput = _e.handleInput, handleInputBlur = _e.handleInputBlur, handleInputFocus = _e.handleInputFocus, displayValue = _e.displayValue;
    var isMinusDisabled = min >= value || disabled;
    var isPlusDisabled = max <= value || disabled;
    return (react_1.default.createElement("div", __assign({ "data-test": "stepper", className: (0, classnames_1.default)(Stepper_module_scss_1.default.stepper, className) }, rest),
        react_1.default.createElement("button", { "aria-label": "decrease quantity", className: Stepper_module_scss_1.default.button, disabled: isMinusDisabled, onClick: handleDecrement },
            react_1.default.createElement(Minus24PxOutlined_1.default, { iconState: isMinusDisabled ? 'icon-disabled' : undefined })),
        react_1.default.createElement(Input_1.default, { ariaLabel: "quantity selected", className: Stepper_module_scss_1.default.input, disabled: disabled, id: inputId, name: inputName, onBlur: handleInputBlur, onChange: handleInput, onFocus: handleInputFocus, type: "number", value: displayValue }),
        react_1.default.createElement("button", { "aria-label": "increase quantity", className: Stepper_module_scss_1.default.button, disabled: isPlusDisabled, onClick: handleIncrement },
            react_1.default.createElement(Plus24PxOutlined_1.default, { iconState: isPlusDisabled ? 'icon-disabled' : undefined }))));
};
exports.Stepper = Stepper;
//# sourceMappingURL=Stepper.js.map